import React from 'react';
import { Components } from '../../../styles';
import { token, tokenToPx } from './getToken';

type TypographyVariants = 'display' | 'heading' | 'title' | 'body' | 'label';
function getStyles(
  variant: TypographyVariants
): Record<string, React.CSSProperties | Record<string, React.CSSProperties | Record<string, React.CSSProperties>>> {
  const className = `.BpTypography-variant-${variant}`;
  return {
    [`&${className}`]: {
      fontSize: tokenToPx(`${variant}MediumFontSize`),
      fontWeight: token(`${variant}MediumFontWeight`),
      lineHeight: tokenToPx(`${variant}MediumLineHeight`),
      letterSpacing: tokenToPx(`${variant}MediumLetterSpacing`),
      '&.MuiTypography-gutterBottom': {
        marginBottom: tokenToPx(`${variant}MediumParagraphSpacing`)
      },
      '&.BpTypography-size-large': {
        fontSize: tokenToPx(`${variant}LargeFontSize`),
        fontWeight: token(`${variant}LargeFontWeight`),
        lineHeight: tokenToPx(`${variant}LargeLineHeight`),
        letterSpacing: tokenToPx(`${variant}LargeLetterSpacing`),
        '&.MuiTypography-gutterBottom': {
          marginBottom: tokenToPx(`${variant}LargeParagraphSpacing`)
        }
      },
      '&.BpTypography-size-small': {
        fontSize: tokenToPx(`${variant}SmallFontSize`),
        fontWeight: token(`${variant}SmallFontWeight`),
        lineHeight: tokenToPx(`${variant}SmallLineHeight`),
        letterSpacing: tokenToPx(`${variant}SmallLetterSpacing`),
        '&.MuiTypography-gutterBottom': {
          marginBottom: tokenToPx(`${variant}SmallParagraphSpacing`)
        }
      }
    }
  };
}

export const typographyTheme = {
  MuiTypography: {
    styleOverrides: {
      root: {
        display: 'block',
        ...getStyles('display'),
        ...getStyles('heading'),
        ...getStyles('title'),
        ...getStyles('body'),
        ...getStyles('label'),
        '&.BpTypography-style-italic': {
          fontStyle: 'italic'
        },
        '&.BpTypography-decoration-underline': {
          textDecoration: 'underline'
        },
        '&.BpTypography-display-inline': {
          display: 'inline-block'
        },
        '&.BpTypography-thin.MuiTypography-root': {
          fontWeight: 300
        }
      }
    }
  }
} satisfies Components;
